import { Link } from "react-router-dom";
import { Globe2, Mail, Trophy } from "lucide-react";

const LINKS = [
  { href: "/", label: "Home" },
  { href: "/support", label: "Help" },
  { href: "/accessibility", label: "Accessibility" },
  { href: "/privacy", label: "Privacy" },
  { href: "/terms", label: "Terms" },
];

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 border-t border-white/10 bg-gradient-to-r from-[var(--brand-primary)] to-[var(--brand-secondary)] text-white">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 px-4 py-7 sm:px-6 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/15 ring-1 ring-white/20">
            <Trophy className="h-5 w-5" />
          </span>
          <div>
            <p className="font-bold">STEP-TEMBER</p>
            <p className="text-xs text-white/70">
              © {year} Move more, together.
            </p>
          </div>
        </div>

        <div className="flex flex-wrap gap-x-5 gap-y-2 text-sm">
          <a
            href="https://www.step-tember.com"
            className="inline-flex items-center gap-1.5 text-white/80 transition-colors hover:text-white"
          >
            <Globe2 className="h-4 w-4" />
            www.step-tember.com
          </a>
          <a
            href="mailto:hello@step-tember.com"
            className="inline-flex items-center gap-1.5 text-white/80 transition-colors hover:text-white"
          >
            <Mail className="h-4 w-4" />
            hello@step-tember.com
          </a>
        </div>

        <nav
          aria-label="Footer"
          className="flex flex-wrap items-center gap-x-4 gap-y-2 text-sm"
        >
          {LINKS.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className="text-white/80 transition-colors hover:text-white"
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
}
